import { useState, useRef, useEffect } from "react";

export function useElementHeight(cssVariableName) {
  const [height, setHeight] = useState(0);
  const elementRef = useRef(null);
  useEffect(() => {
    setInterval(() => {
      if (elementRef.current) {
        if (height !== elementRef.current.clientHeight) {
          setHeight(elementRef.current.clientHeight);
        }
      }
    }, 1000);
  }, []);
  useEffect(() => {
    console.log(height);
    if (cssVariableName) {
      document.documentElement.style.setProperty(
        cssVariableName,
        `${height}px`
      );
    }
  }, [height]);
  return [elementRef, height];
}
